import Requestor from '@/api/Requestor';
import { clientInstance } from '@/api/core';
class StoreApi extends Requestor {
    getVirtualBanksByStore({ storeId }) {
        return this.get({
            url: `/api/v1/stores/${storeId}/virtual-banks`,
        });
    }
    getStoreList(params = {}) {
        return this.get({
            url: '/api/v1/stores',
            params,
        });
    }
    getStore(storeId = '', params = {}) {
        return this.get({
            url: `/api/v1/stores/${storeId}`,
            params,
        });
    }
    postStore(data = {}) {
        return this.post({
            url: '/api/v1/stores',
            data,
        });
    }
    // 상점상세 - 수정
    putStoreBasic(storeId = '', type = '', data = {}) {
        return this.put({
            url: `/api/v1/stores/${storeId}/${type}`,
            data,
        });
    }
    /**
     * 운행설정 적용
     * https://dev-zoo-client-api.barogo.io/docs/api-guide.html#_3_3_%ED%97%88%EB%B8%8C_%EC%9A%B4%ED%96%89_%EC%84%A4%EC%A0%95
     * @param {Object} data
     * @returns {Object}
     */
    postOperationSetting(data) {
        return this.post({
            url: '/api/v1/stores/operation-setting',
            data,
        });
    }
    // 상점 구간별 관리비 설정 (C,R,U,D)
    postStoreManagementFeeBySection(storeId = '', data = {}) {
        return this.post({
            url: `/api/v1/stores/${storeId}/management-fee-by-sections`,
            data,
        });
    }
    getStoreManagementFeeBySection(storeId = '', params = {}) {
        return this.get({
            url: `/api/v1/stores/${storeId}/management-fee-by-sections`,
            params,
        });
    }
    putStoreManagementFeeBySection(storeId = '', feeId = '', data = {}) {
        return this.put({
            url: `/api/v1/stores/${storeId}/management-fee-by-sections/${feeId}`,
            data,
        });
    }
    deleteStoreManagementFeeBySection(storeId = '', feeId = '') {
        return this.delete({
            url: `/api/v1/stores/${storeId}/management-fee-by-sections/${feeId}`,
        });
    }
    // 상품할증 설정 (C,R,U,D)
    postStoreGoodsPriceSurchargeInfos(storeId = '', data = {}) {
        return this.post({
            url: `/api/v1/stores/${storeId}/goods-price-surcharge-infos`,
            data,
        });
    }
    getStoreGoodsPriceSurchargeInfos(storeId = '', params = {}) {
        return this.get({
            url: `/api/v1/stores/${storeId}/goods-price-surcharge-infos`,
            params,
        });
    }
    putStoreGoodsPriceSurchargeInfos(storeId = '', surchargeId = '', data = {}) {
        return this.put({
            url: `/api/v1/stores/${storeId}/goods-price-surcharge-infos/${surchargeId}`,
            data,
        });
    }
    deleteStoreGoodsPriceSurchargeInfos(storeId = '', surchargeId = '') {
        return this.delete({
            url: `/api/v1/stores/${storeId}/goods-price-surcharge-infos/${surchargeId}`,
        });
    }
    /**
     * 배달 가능 동 조회
     */
    getStoreDeliveryPossibleAreas(storeId = '', params = {}) {
        return this.get({
            url: `/api/v1/stores/${storeId}/delivery-possible-areas`,
            params,
        });
    }
    /**
     * 배달 가능 동 추가/제외
     */
    postStoreDeliveryPossibleAreas(storeId = '', data = {}) {
        return this.post({
            url: `/api/v1/stores/${storeId}/delivery-possible-areas`,
            data,
        });
    }
    /**
     * 상점의 배달대행료
     */
    getDeliveryChargeList(storeId, params = {}) {
        return this.get({
            url: `/api/v1/stores/${storeId}/delivery-charges`,
            params,
        });
    }
    /**
     * 상점의 배달대행료 삭제
     */
    deleteDeliveryChargeList(storeId, data = {}) {
        return this.delete({
            url: `/api/v1/stores/${storeId}/delivery-charges`,
            data,
        });
    }
    /**
     * 상점의 배달대행료 추가
     */
    postDeliveryCharge(storeId, data) {
        return this.post({
            url: `/api/v1/stores/${storeId}/delivery-charges`,
            data,
        });
    }
    /**
     * 상점의 배달대행료 수정
     */
    putDeliveryCharge(storeId, deliveryChargeId, data) {
        return this.put({
            url: `/api/v1/stores/${storeId}/delivery-charges/${deliveryChargeId}`,
            data,
        });
    }
}
export default new StoreApi(clientInstance);
